export const enumTypeCompetence = {
    SAVOIR : "Savoir",
    SAVOIRFAIRE : "SavoirFaire",
    SAVOIRETRE : "SavoirEtre"
}